import { CATEGORY } from '../../features/category/router/enums/category';
import { ARTICLE } from '../../features/article/router/enums/article';

export const ROUTES = {
  FARMAPROM: 'https://moj.farmaprom.pl',
  DEFAULT: '/',
  ERROR_503: '/error/503',
  ERROR_404: '/error/404',
  ERROR_403: '/error/403',
  ERROR_401: '/error/401',
  DASHBOARD: '/dashboard',
  CATEGORY: CATEGORY,
  ARTICLE: ARTICLE,
};
